module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAYCAMAAAAMEmfoAAAAQlBMVEUbUYNqmr56qM2Vwuk9cZdIe59UhqknXImbxu4uYo0yZ5BbjLCPvOMhVoVDdpuJttxik7eBr9U4bJNOgaRyocaeyvJ5NGziAAAAKUlEQVR4Xg3BhQHAIAAAIGzX/f+rE3y6ZHW4RK/gtKgexS67zSZt3OAHGTYA7y09nMkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./assets/images/percent-male.png
// module id = 523
// module chunks = 0